<app-auth-page-layout>
    <div class="interested-page min-h-screen flex justify-center px-4 pb-16 flex-col flex-1">

        <div class="w-full max-w-4xl flex flex-col items-center justify-evenly relative py-8">

            <!-- Headline -->
            <div class="text-center mb-4 fade-in-0">
                <h1 class="text-4xl md:text-5xl font-bold text-brand-500 tracking-tight leading-tight">
                    Become a merchant
                </h1>
                <p class="text-gray-500 mt-3 text-lg max-w-xl mx-auto leading-relaxed">
                    And start selling on the LoveGivr platform
                </p>
            </div>

            <!-- Step 1 -->
            <div class="bubble-container flex justify-center items-center w-full md:w-[65%] my-4 self-start fade-in-1
                flex-col-reverse md:flex-row gap-4">
                <div class="step-info w-full md:w-auto md:mx-12 text-center md:text-left">
                    <b class="text-lg font-semibold text-gray-800 block mb-1">
                        1. Sign up as a merchant
                    </b>
                    <p class="text-base text-gray-500 m-0">
                        Register your merchant profile on the platform first and verify your email.
                    </p>
                </div>
                <!-- Light brand color bubble -->
                <div class="bubble-small bubble-shadow flex-shrink-0 rounded-full p-6 flex items-center justify-center"
                    style="background: #DE4F78;">
                    <i class="fi fi-bs-enter text-white text-5xl flex"></i>
                </div>
            </div>

            <!-- Step 2 -->
            <div class="bubble-container flex justify-center items-center w-full md:w-[65%] my-4 self-end fade-in-2
                flex-col md:flex-row gap-4">
                <!-- Dark → light gradient bubble -->
                <div
                    class="bubble-medium bubble-shadow bubble-gradient flex-shrink-0 rounded-full p-16 flex items-center justify-center">
                    <i class="fi fi-ss-building text-white text-7xl flex"></i>
                </div>
                <div class="step-info w-full md:w-auto md:mx-12 text-center md:text-left">
                    <b class="text-lg font-semibold text-gray-800 block mb-1">
                        2. Fill organizational and taxing form
                    </b>
                    <p class="text-base text-gray-500 m-0">
                        In order to sell legally on our platform you need to provide:
                    </p>
                    <ul class="text-base text-gray-500 list-disc pl-5 mt-2 space-y-1">
                        <li>Contact information</li>
                        <li>Banking details</li>
                        <li>Legal name</li>
                        <li>Registration number</li>
                        <li>Address</li>
                        <li>VAT number</li>
                    </ul>
                </div>
            </div>

            <!-- Step 3 -->
            <div class="bubble-container flex justify-center items-center w-full md:w-[65%] my-4 self-start fade-in-3
                flex-col-reverse md:flex-row gap-4">
                <div class="step-info w-full md:w-auto md:mx-12 text-center md:text-left">
                    <b class="text-lg font-semibold text-gray-800 block mb-1">
                        3. Admin verification
                    </b>
                    <p class="text-base text-gray-500 m-0">
                        An admin needs to verify and approve your shop before it becomes available on for the users.
                    </p>
                </div>
                <!-- Dark brand color bubble -->
                <div class="bubble-big bubble-shadow flex-shrink-0 rounded-full p-10 flex items-center justify-center"
                    style="background: #D31148;">
                    <i class="fi fi-ss-following text-white text-5xl flex"></i>
                </div>
            </div>

            <!-- CTA Button -->
            <button class="cta-button fade-in-4 mt-8 px-10 py-4 rounded-full text-white font-semibold text-lg tracking-wide
         shadow-lg transition-all duration-300 hover:scale-105 hover:shadow-xl active:scale-95"
                [routerLink]="['/register-merchant']">
                Register your merchant profile now
            </button>


        </div>
    </div>
</app-auth-page-layout>